import { render, staticRenderFns } from "./BlogLinkSuggestion.vue?vue&type=template&id=e15058c0&scoped=true"
import script from "./BlogLinkSuggestion.vue?vue&type=script&lang=js"
export * from "./BlogLinkSuggestion.vue?vue&type=script&lang=js"
import style0 from "./BlogLinkSuggestion.vue?vue&type=style&index=0&id=e15058c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15058c0",
  null
  
)

export default component.exports